export enum CustomPageType {
  CampaignPage = 'CampaignPage',
  ArticlePage = 'RosaArticlePage',
  TagPage = 'RosaTagPage',
}
